/* eslint-disable react/prop-types */
import { Link } from "react-router-dom";

const RoundedButton = ({ children, href, className, external = false }) => {
  const ButtonContent = () => (
    <button
      className={`relative px-6 py-2.5 overflow-hidden font-semibold text-black group ${className}`}
    >
      {/* L-shaped border corners */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-0 w-4 h-full border-l-[3px] border-t-[3px] border-primary"></div>
        <div className="absolute top-0 right-0 w-4 h-4 border-r-[3px] border-t-[3px] border-primary"></div>
        <div className="absolute bottom-0 left-0 w-4 h-full border-b-[3px] border-l-[3px] border-primary"></div>
        <div className="absolute bottom-0 right-0 w-4 h-full border-b-[3px] border-r-[3px] border-primary"></div>
      </div>

      {/* Hover background effect */}
      <div className="absolute inset-0 group-hover:opacity-100 bg-primary transition-all scale-0 opacity-0 group-hover:scale-100 duration-500 ease-in-out origin-center"></div>

      {/* Button text */}
      <span className="relative z-10 transition-colors duration-500 ease-in-out group-hover:text-white">
        {children}
      </span>
    </button>
  );

  return external ? (
    <a href={href} target="_blank" rel="noopener noreferrer">
      <ButtonContent />
    </a>
  ) : (
    <Link to={href}>
      <ButtonContent />
    </Link>
  );
};

export default RoundedButton;
